import { Moment } from "moment";
import { AppThunk, AppDispatch } from "../../types";
import fetchReport from "../../../shared/fetchReport";

type FetchReceivedAdsWtdProps = {
  startDate: Moment;
  endDate: Moment;
  report: string;
};
export type FetchReceivedAdsWtd = (filters: FetchReceivedAdsWtdProps) => void;

const fetchReceivedAdsWtd = ({
  startDate,
  endDate,
  report
}: FetchReceivedAdsWtdProps): AppThunk => async (dispatch: AppDispatch) => {
  const params = {
    start_date: startDate.format("YYYY-MM-DD"),
    end_date: endDate.format("YYYY-MM-DD"),
  };
  await fetchReport(report, dispatch, params);
};

export default fetchReceivedAdsWtd;
